"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canEmailContactWithoutOptIn = exports.areCommunicationPreferencesPreselected = exports.COMMUNICATION_CONSENT_BY_COUNTRY = void 0;
const country_1 = require("../enums/country");
// Pre-ticking relies on implied consent (US, CA, AU, NZ); only Germany forbids emailing without an opt-in.
exports.COMMUNICATION_CONSENT_BY_COUNTRY = {
    [country_1.OrganizationCountry.UnitedStates]: { canPreselect: true, canEmailWithoutOptIn: true },
    [country_1.OrganizationCountry.Canada]: { canPreselect: true, canEmailWithoutOptIn: true },
    [country_1.OrganizationCountry.GreatBritain]: { canPreselect: false, canEmailWithoutOptIn: true },
    [country_1.OrganizationCountry.Australia]: { canPreselect: true, canEmailWithoutOptIn: true },
    [country_1.OrganizationCountry.NewZealand]: { canPreselect: true, canEmailWithoutOptIn: true },
    [country_1.OrganizationCountry.Ireland]: { canPreselect: false, canEmailWithoutOptIn: true },
    [country_1.OrganizationCountry.Germany]: { canPreselect: false, canEmailWithoutOptIn: false },
};
const areCommunicationPreferencesPreselected = (country) => Boolean(country && exports.COMMUNICATION_CONSENT_BY_COUNTRY[country].canPreselect);
exports.areCommunicationPreferencesPreselected = areCommunicationPreferencesPreselected;
const canEmailContactWithoutOptIn = (country) => exports.COMMUNICATION_CONSENT_BY_COUNTRY[country].canEmailWithoutOptIn;
exports.canEmailContactWithoutOptIn = canEmailContactWithoutOptIn;
